import SystemTypeCreate from './create';
import SystemTypeList from './list';
import SystemTypeShow from './show';
import SystemTypeEdit from './edit';

export default {
    create: SystemTypeCreate,
    list: SystemTypeList,
    show: SystemTypeShow,
    edit: SystemTypeEdit,
};